module.exports = __webpack_public_path__ + "static/media/lang-en.07877822.svg";